import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { colors } from '../../theme/colors';
import { rem } from '../../utilities/style';
import { fontWeights } from '../../theme/type';

import { ReactComponent as IconArrowRight } from '../../images/icons/arrow-right.svg';
import Link from '../Link';

const ButtonStyled = styled(Link, {
  shouldForwardProp: (prop) => !['arrow', 'color', 'theme'].includes(prop)
})`
  label: secondary;
  display: inline-flex;
  align-items: center;
  font-weight: ${fontWeights.semiBold};
  font-size: 1rem;
  line-height: 1.2;
  text-decoration: underline;
  cursor: pointer;

  ${({ color }) => (color === 'dark' ? `
    color: ${colors.blue['800']};
  ` : `
    color: ${colors.gray['50']};
  `)}

  ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
    color: ${colors.blue['100']};
  `}

  ${({ arrow }) => arrow && `
    text-decoration: none;
  `}

  &:hover {
    text-decoration: none;
  }
`;

const Arrow = styled(IconArrowRight)`
  margin-left: ${rem(16)};
  transform: translateX(${rem(-8)});
  transition: transform .2s ease;

  ${ButtonStyled}:focus &,
  ${ButtonStyled}:hover & {
    transform: none;
  }
`;

const ButtonText = ({ children, arrow = false, color = 'dark', ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <ButtonStyled arrow={arrow} color={color} {...rest}>
    {children}
    {arrow && <Arrow aria-hidden="true" />}
  </ButtonStyled>
);

ButtonText.propTypes = {
  ...Link.propTypes,
  children: PropTypes.node.isRequired,
  arrow: PropTypes.bool,
  color: PropTypes.oneOf(['dark', 'light'])
};

// Convert to styled component so we can reference it in other component styles
export default styled(ButtonText)();
